// navData order: back, search company, superadmin, operatore, company sections (see config-navigation).
export function selectNavGroups(navData, user) {
  const company = Boolean(user?.data?.current_company);
  return [
    company ? navData[0] : navData[1],
    ...(!company ? [navData[3]] : []),
    ...(!company && user?.groups?.includes('Studio') ? [navData[2]] : []),
    ...(company ? navData.slice(4) : []),
  ];
}
